import React from 'react';
import { Form, Field } from 'react-final-form';
import { H3, Modal, PrimaryButton } from '../../components';
import { useDispatch } from 'react-redux';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import ShippingFeeInputField from '../EditListingPage/EditListingWizard/EditListingInfoPanel/ShippingFeeInputField';
import { getPriceValidators } from '../../util/validators';
import css from './ShippingDetailsPage.module.css'; // ← better to have own css if needed
import { isArrayLength } from '../../util/genericHelpers';
import { updateListing } from './ShippingDetailsPage.duck';
import { showErrorToast, showSuccessToast } from '../../util/toast';

const ShippingPriceInputFieldModal = ({
  isOpen,
  onClose,
  listingsMissingShippingPrice = [], // default empty array
  intl,
  config,
}) => {
  const dispatch = useDispatch();
  const marketplaceCurrency = config?.currency || 'USD'; // fallback
  const listingMinimumPriceSubUnits = config?.listingMinimumPriceSubUnits || 0;

  const priceValidators = getPriceValidators(
    listingMinimumPriceSubUnits,
    marketplaceCurrency,
    intl
  );

  // Dynamic title based on number of listings
  const numListings = listingsMissingShippingPrice.length;
  const titleMessageId =
    numListings === 1
      ? 'ShippingPriceInputFieldModal.titleOneListing'
      : 'ShippingPriceInputFieldModal.titleMultipleListings';

  const onSubmit = async values => {
    try {
      const { shippingPriceInSubunitsOneItem } = values || {};
      const listingsMissingShippingIds = isArrayLength(listingsMissingShippingPrice)
        ? listingsMissingShippingPrice?.map(listing => listing.id)
        : []; // default empty array

      const listingParams = {
        ids: listingsMissingShippingIds,
        shippingPriceInSubunitsOneItem,
      };
      await dispatch(updateListing(listingParams));
      showSuccessToast('Shipping price updated successfully.');
    } catch (error) {
      showErrorToast('Error while updating the shipping price. Please try again.');
    } finally {
      onClose();
    }
  };

  return (
    <Modal
      id="ShippingPriceInputFieldModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={(componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling))
      }
      usePortal
      hideCloseButton
    >
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, submitting, pristine }) => (
          <form onSubmit={handleSubmit}>
            <H3 as="h3">{intl.formatMessage({ id: titleMessageId }, { count: numListings })}</H3>

            <Field
              name="shippingPriceInSubunitsOneItem"
              component={ShippingFeeInputField}
              intl={intl}
              marketplaceCurrency={marketplaceCurrency}
              priceValidators={priceValidators}
            />

            <div className={css.buttonGroup}>
              <PrimaryButton
                type="submit"
                className={css.submitButton}
                disabled={submitting || pristine}
                inProgress={submitting}
              >
                {intl.formatMessage({ id: 'ShippingPriceInputFieldModal.submit' })}
              </PrimaryButton>
            </div>
          </form>
        )}
      />
    </Modal>
  );
};

export default ShippingPriceInputFieldModal;
